import { SeletorEmpresa } from '../../nucleo/empresa/SeletorEmpresa';

/**
 * Fase 2: encaixe da barra superior (W1) para o seletor de empresa (W2a). O componente some sozinho quando o
 * workspace tem uma empresa só. Review r16 visual M1: no desktop, até 14rem na barra. Review r17 visual M1 e B3: no
 * celular, numa linha própria do cabeçalho (abaixo da faixa de índices), do tamanho do nome e no máximo a linha inteira
 * (sem o valor arbitrário de 55%).
 */
export function SeletorEmpresaBarra({ celular = false }: { celular?: boolean }) {
  return <SeletorEmpresa className={celular ? 'min-w-0 max-w-full' : 'min-w-0 max-w-56'} />;
}
